import image1 from "../assets/webimg1.png";
import image2 from "../assets/webimg2.png";
import image3 from "../assets/webimg3.png";

export const webData = [
  {
    image: image1,
    review:
      "Website for Restaurant with awesome looking UI. And full functional and responsive front-end and planing to create backend also. Added location feature with google maps",
    name: "Restaurant Website",
    used: "HTML/CSS/JavaScript",
    link: "https://harsha-99-tech.github.io/Fav-Food-Rest/",
  },
  {
    image: image2,
    review:
      "Portfolio website for myself. Developed using React with EmailJS. Fully functional and added some amazing animations. Used other UI design and edited it suits for my case.",
    name: "Portfolio-Harsha Nawana",
    used: "React/EmailJS",
    link: "https://example",
  },
  {
    image: image3,
    review:
      "Website for Sport management in University. For managing sports and post news updates about sports. Added admin panel and coach and student registration also.",
    name: "Sport Management Site",
    used: "PHP/HTML/CSS/JavaScript",
    link: "https://rusl-sports.000webhostapp.com",
  },
];
